export default {
  selectedWithCount: '{contentName} {number}개 선택됨',
  shareEntireDirectory: '전체 디렉토리 공유',
  afterOpenTips:
    '활성화 후 전체 디렉토리의 모든 콘텐츠가 공유됩니다.\n(이 디렉토리에 나중에 추가되는 콘텐츠도 자동으로 공유됩니다.)',
  afterOpenTipsTwo:
    '전체 디렉토리의 모든 콘텐츠가 공유됩니다. (이 디렉토리에 나중에 추가되는 콘텐츠도 자동으로 공유됩니다.)',
  noContent: '데이터 없음',
  selectAll: '전체 선택',
  all: '전체',
  notSelectAnyWithName: '{name}을(를) 선택하지 않았습니다.',
  cancel: '취소',
  confirm: '확인',
  customExpression: '사용자 지정 표현식',
  noPermission: '권한 없음',
  enumeratedValue: '열거형 값',
  description: '설명',
  required: '필수',
  optional: '선택 사항',
  default: '기본값',
  length: '길이',
  format: '데이터 형식',
  enum: '열거형',
  regexp: '정규식',
  and: '그리고',
  value: '값',
  arrayLength: '길이',
  uniqueItems: '요소 고유',
  const: '상수 값',
  multipleOf: '{multipleOf}의 배수',
  propertiesLength: '속성 수',
  additionalItems: '추가 항목',
  additionalProperties: '추가 속성',
  writeOnly: '쓰기 전용',
  readOnly: '읽기 전용',
  examples: '예시 값',
  externalDocs: '외부 문서',
  isCopied: '복사됨',
  copyToClipboard: '클릭하여 복사',
  'overView.isCopied': '복사됨',
  'overView.failToCopied': '복사 실패, 수동으로 복사하세요.',
  'component.tagSelect.expand': '펼치기',
  'component.tagSelect.collapse': '접기',
  deprecated: '사용 중단됨',
  'error.url': 'URL 형식 오류: {url}',
  note: '비고',
  tip: '팁',
  info: '정보',
  caution: '주의',
  danger: '위험',
  warning: '경고',
  check: '확인',
  name: '이름',
  'codeEditor.copy': '코드 복사',
  'codeEditor.format': '형식 지정',
  'codeEditor.showEditor': '콘텐츠 표시',
  'schemaGenerator.code': ' 코드',
  'schemaGenerator.codeGenerate': '모델 코드 생성',
  'schemaGenerator.more': '더 보기',
  'schemaGenerator.name': '데이터 모델 이름',
  'schemaGenerator.commaSeparator': ',',
  'codeEditor.wrap': '자동 줄 바꿈',
  'inbox.MarkAllAsRead': '모두 읽음으로 표시',
  'environment.manageModal.tip.clickToSetVariable': '변수 설정 클릭: ',
  'environment.variable.notSet': '설정되지 않음',
  'httpCode.shortName.200': '성공',
  'httpCode.shortName.201': '성공',
  'httpCode.shortName.202': '성공',
  'httpCode.shortName.204': '삭제 성공',
  'httpCode.shortName.400': '요청 오류',
  'httpCode.shortName.401': '권한 없음',
  'httpCode.shortName.403': '접근 금지',
  'httpCode.shortName.404': '레코드 없음',
  'httpCode.shortName.410': '레코드 없음',
  'httpCode.shortName.422': '매개변수 오류',
  'httpCode.shortName.500': '서버 오류',
  'httpCode.shortName.502': '게이트웨이 오류',
  'httpCode.shortName.503': '서버 오류',
  'httpCode.shortName.504': '게이트웨이 시간 초과',
};
